import * as React from 'react';
import { ICertificateData } from '../../entities/table';
import Table from '../Table';
import { Body } from './Body';
import { Head } from './Head';
import Toolbar from './Toolbar';

interface IProps {
  rows: ICertificateData[]
  onRowClick?: (row: ICertificateData) => void
  onDelete?: (row: ICertificateData) => void
}

export const GlobalSearchTable: React.FC<IProps> = ({rows, onRowClick, onDelete}) => {
  return <Table Head={Head} Body={Body} rows={rows} Toolbar={Toolbar} onRowClick={onRowClick ? onRowClick : () => {}} onDelete={onDelete} />;
}